import { RouteComponentProps, withRouter } from 'react-router-dom';
import ObjednavkaStore from 'src/stores/ObjednavkaStore';
import * as React from 'react'
import { inject, observer } from 'mobx-react';
import {
    Drawer,
    Grid,
    AppBar,
    Toolbar,
    IconButton,
    Typography,
    Paper,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Fab,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    TextField,
    DialogActions,
    Button,
    Tooltip,
    MenuItem, CircularProgress
} from '@material-ui/core';
import NavigationDrawerItems from './NavigationDrawerItems';
import { observable, action, computed } from 'mobx';
import MenuIcon from '@material-ui/icons/Menu';
import AddIcon from '@material-ui/icons/Add';
import Objednavka from 'src/models/Objednavka';
import moment from 'moment'
import TurnusStore from 'src/stores/TurnusStore';
import KlientStore from 'src/stores/KlientStore';
import {DatePicker} from "material-ui-pickers";
import ReportStore from "../stores/ReportStore";

export interface ISmartEmailingProps extends RouteComponentProps<any> {
    reportStore?: ReportStore;
}

@inject('reportStore')
@observer
class SmartEmailingReport extends React.Component<ISmartEmailingProps>{

    constructor(props: Readonly<ISmartEmailingProps>) {
        super(props);
        props.reportStore.loadEmailsCount().then( success => {
            this.emailsCount = props.reportStore.smartEmailingCount;
        })
        console.log("LOAD: WebOrders");
    }

    @observable private isDrawerOpened: boolean = false;
    @observable private emailsCount: number = null;

    @action
    private drawerMenuClick = event => {
        this.isDrawerOpened = !this.isDrawerOpened;
    }

    public render() {
        return (
            <div>
                <Drawer open={this.isDrawerOpened} onClose={this.drawerMenuClick}>
                    <NavigationDrawerItems />
                </Drawer>

                <Grid container spacing={8}>
                    <Grid item xs={12}>
                        <AppBar position="static" >
                            <Toolbar>
                                <IconButton color="inherit" aria-label="Menu" onClick={this.drawerMenuClick}>
                                    <MenuIcon />
                                </IconButton>
                                <Typography variant="h6" color="inherit"  style={{ flexGrow: 1 }}>
                                    Smart emailing export
                                </Typography>
                            </Toolbar>
                        </AppBar>
                    </Grid>
                    <Grid item xs={12} style={{ margin: 8 }}>
                        <Paper style={{ padding: 8 }}>
                            {this.emailsCount !== null ?
                            <Grid item xs={6} style={{ margin: 'auto', alignItems: 'center' }} container>
                                <span style={{ marginRight: 20, flexBasis: 250 }}>Nové emaily: ({this.props.reportStore.smartEmailingCount})</span>
                                <Button href={this.props.reportStore.getEmailsCSVUrl()}>Stáhnout</Button>
                            </Grid>
                            :
                            <Grid item xs={1} style={{ margin: 'auto', alignItems: 'center' }} container>
                                <CircularProgress />
                            </Grid>}
                        </Paper>
                    </Grid>
                </Grid>
            </div>
        );
    }
}

export default withRouter(SmartEmailingReport);


// WEBPACK FOOTER //
// ./src/components/SmartEmailingReport.tsx